import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { rulesBuilder, usePageForm } from 'scbk-shared-module/modules/Form';
import {
  FieldRound,
  FieldWrapper,
  Radio,
  SelectionDesc,
  SelectionSummary,
  SelectionTitle,
} from 'scbk-ui-web';
import { useDeviceAuthStore } from '../stores/useDeviceAuthStore';

interface DeviceAuthProps {
  deviceAlias: string;
}

interface Props {
  trigger: number;
}

const DeviceAuthStep2Component: React.FC<Props> = ({ trigger }) => {
  const { t } = useTranslation();

  const { maskMacAddress, setDeviceAlias, setAllowOtherDeviceYn, setStep } = useDeviceAuthStore();
  const deviceAliasRef = useRef<HTMLInputElement>(undefined);

  const form = usePageForm<DeviceAuthProps>({
    defaultValues: {
      deviceAlias: '',
    },
    onSubmitError: (error) => {
      console.log('# onSubmitError ', error);
    },
  });

  const fields = form.useFields({
    deviceAlias: {
      rules: rulesBuilder<DeviceAuthProps>()
        .required(t('DeviceAuthComponent.024', '별명을 입력해 주세요.'))
        .maxLength(20, t('', ''))
        .build(),
    },
  });

  const handleSubmit = form.submit(async () => {
    setStep(3);
  });

  useEffect(() => {
    if (trigger === 0) return;
    handleSubmit();
  }, [trigger]);

  useEffect(() => {
    form.setFocus('deviceAlias');
  }, []);

  return (
    <>
      <h2 className="page-heading-title mb-8">
        {t('DeviceAuthComponent.025', '지정할 단말기 정보를 입력해 주세요')}
      </h2>

      <SelectionSummary>
        <SelectionTitle>{t('DeviceAuthComponent.026', '지정할 단말 정보')}</SelectionTitle>
        <SelectionDesc>{maskMacAddress}</SelectionDesc>
      </SelectionSummary>

      {/* 260527 클래스 수정 */}
      <div className="flex flex-col gap-8 mt-8">
        <FieldWrapper
          labelFor="deviceAlias"
          title={t('DeviceAuthComponent.027', '별명')}
          isError={form.isError('deviceAlias')}
          helpMessage={form.getFieldError('deviceAlias')}
        >
          <FieldRound
            {...fields.deviceAlias.inputProps}
            id="deviceAlias"
            value={fields.deviceAlias.value ?? ''}
            maxLength={20}
            placeholder={t('DeviceAuthComponent.035', '최대 20자리')}
            ref={deviceAliasRef}
            onChange={(v) => {
              if (v.target.value.length > 20) {
                form.setValue('deviceAlias', v.target.value.slice(0, 20));
                setDeviceAlias(v.target.value.slice(0, 20));
                deviceAliasRef.current?.blur();
                setTimeout(() => {
                  deviceAliasRef.current?.focus();
                }, 10);
                return false;
              }
              form.setValue('deviceAlias', v.target.value);
              setDeviceAlias(v.target.value);
            }}
            error={form.isError('deviceAlias')}
          />
        </FieldWrapper>

        <FieldWrapper
          labelFor="field-text"
          title={t('DeviceAuthComponent.029', '미지정 단말기 거래 허용')}
        >
          <div className="form-item-default-col">
            <Radio
              variants="button-radio"
              id="allowOtherDeviceN"
              label={t('DeviceAuthComponent.030', '허용하지 않음')}
              value="N"
              name="allowOtherDeviceYn"
              defaultChecked={true}
              onChange={() => {
                setAllowOtherDeviceYn('N');
              }}
            />
            <Radio
              variants="button-radio"
              id="allowOtherDeviceY"
              label={t('DeviceAuthComponent.031', '허용함 (추가인증 후 인증서 및 이체거래 가능)')}
              value="Y"
              name="allowOtherDeviceYn"
              onChange={() => {
                setAllowOtherDeviceYn('Y');
              }}
            />
          </div>
        </FieldWrapper>
      </div>
    </>
  );
};

export default DeviceAuthStep2Component;
